module.exports = __webpack_public_path__ + "static/media/Logo.4f82cd73.svg";